import React, { useContext, useEffect } from "react";
import MyContext from "../context/MyContext";
import axios from "axios";
import PaypalButton from "./PaypalButton";
import { NavLink, useHistory } from "react-router-dom";

const Cart = () => {
  const history = useHistory();
  const { cart, setCart, total, setTotal, user, callback, setCallback } =
    useContext(MyContext);

  useEffect(() => {
    const getTotal = () => {
      const total = cart.reduce((prev, item) => {
        return prev + item.price * item.quantity;
      }, 0);
      setTotal(total);
    };
    getTotal();
  }, [cart, setTotal]);

  const addToCart = async (cart) => {
    await axios.patch("/users/addcart", { cart });
  };

  const increment = (id) => {
    cart.forEach((item) => {
      if (item._id === id) {
        item.quantity += 1;
      }
    });
    setCart([...cart]);
    addToCart(cart);
  };

  const decrement = (id) => {
    cart.forEach((item) => {
      if (item._id === id) {
        item.quantity === 1 ? (item.quantity = 1) : (item.quantity -= 1);
      }
    });
    setCart([...cart]);
    addToCart(cart);
  };

  const removeProduct = (id) => {
    if (window.confirm("Do you want to delete this product?")) {
      cart.forEach((item, index) => {
        if (item._id === id) {
          cart.splice(index, 1);
        }
      });
      setCart([...cart]);
      addToCart(cart);
    }
  };

  const tranSuccess = async (payment) => {
    const { paymentID, billAddress } = payment;
    await axios.post("/api/payments", { cart, paymentID, billAddress });
    setCart([]);
    addToCart([]);
    history.push("/orderhistory");
    alert("You have successfully placed an order.");
  };

  if (cart.length === 0)
    return (
      <>
        <h2
          style={{
            textAlign: "center",
            fontSize: "5rem",
            padding: "2rem",
            marginTop: "4rem",
          }}
        >
          Cart Empty
        </h2>
        <NavLink to="/">
          <h1
            style={{
              textAlign: "center",
              padding: "2rem",
            }}
          >
            Let's Shop!
          </h1>
        </NavLink>
      </>
    );
  const goTo = () => {
    setCallback(!callback);
    history.push("/addAddress");
  };

  return (
    <div className="our-cart">
      {cart.map((product) => (
        <div className="cart" key={product._id}>
          <img src={product.images[0].url} alt="" />

          <div className="cart-box">
            <h2>{product.title}</h2>
            <h3>{product.price * product.quantity} €</h3>
            <p>{product.description}</p>
            <p>{product.content}</p>

            <div className="amount">
              <button onClick={() => decrement(product._id)}> - </button>
              <span>{product.quantity}</span>
              <button onClick={() => increment(product._id)}> + </button>
            </div>

            <div className="delete" onClick={() => removeProduct(product._id)}>
              X
            </div>
          </div>
        </div>
      ))}

      <div className="total">
        <h3>Total: {total} €</h3>
        {user && user.deliveryaddress.length > 0 ? (
          <PaypalButton total={total} tranSuccess={tranSuccess} />
        ) : (
          <button type="submit" onClick={goTo}>
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default Cart;
